import { render, staticRenderFns } from "./GoodDetails.vue?vue&type=template&id=3219725a&scoped=true"
import script from "./GoodDetails.vue?vue&type=script&lang=js"
export * from "./GoodDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodDetails.vue?vue&type=style&index=0&id=3219725a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3219725a",
  null
  
)

export default component.exports